<template>
  <div class="list">
    <app-list></app-list>
</div>
</template>

<script>
import List from '@/components/List'

export default {
  name: 'home',
  components: {
    'app-list': List,
  }
}
</script>

<style lang="scss">
.about {
  .ttl {
    text-transform: initial;
  }
  .ttu {
    text-transform: uppercase;
  }
  .m-mt {
    @include media_query(mobile-port) {
      margin-top: 4rem;
    }
  }
}
</style>
